import { render, staticRenderFns } from "./Desentif.vue?vue&type=template&id=5810efeb&scoped=true"
import script from "./Desentif.vue?vue&type=script&lang=js"
export * from "./Desentif.vue?vue&type=script&lang=js"
import style0 from "./Desentif.vue?vue&type=style&index=0&id=5810efeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5810efeb",
  null
  
)

export default component.exports